module.exports = __webpack_public_path__ + "media/images/shopify_faq_7-1d5366f27b8826be4337b2bb730e77ae.png";